<ng-template #tooltipContent>
    <ng-content></ng-content>
</ng-template>

<sup [ngbTooltip]="tooltipContent" [tooltipClass]="tooltipClass">
    <app-icon [ngStyle]="{ 'font-size': iconSize }" [type]="appIconType"></app-icon>
</sup>
